import throttle from '../../../assets/js/base/_throttle.js';

export class SwapNavColors {
	/**
	 * Initialize a new Sections element
	 *
	 * @param {HTMLElement} node - the node that contains the root scrolling element
	 * @param {object} opts -
	 * 	- mode: snap, normal
	 *  - sticky: true
	 */
	constructor( node, opts ) {
		this.node = node;
		// to store original values
		this.cache = [];
		this.masthead = document.querySelector('.masthead');
		this.from     = node.querySelector( '.header__title' );
		this.to       = [
			...document.querySelectorAll('.masthead--top .masthead__link--depth-0'),
			...document.querySelectorAll('.masthead__search-icon'),
		];

		this.init();
	}

	init() {
		window.addEventListener( 'scroll', throttle( () => {
			this.swap();
		}), 100 );

		this.swap();
	}

	check() {
		return this.masthead.classList.contains( 'masthead--immersive' )
			&& this.masthead.classList.contains( 'masthead--top' );
	}
	swap() {
		this.check()
			? this.to.forEach((m) => this.swapOne(m))
			: this.to.forEach((m) => this.swapOneBack(m));
	}

	swapOne(el) {

		// store
		if (!this.cache[el.id]) {
			this.cache[el.id] = el.style.color;
		}
		// set
		el.style.color = window.getComputedStyle(this.from).getPropertyValue('color')
	}

	swapOneBack(el) {
		el.style.color = this.cache[el.id] ?? null;
	}

};


document.querySelectorAll( '.header' ).forEach( ( node ) => {

	if ( node.classList.contains( 'header--media-fixed' ) ) {
		const media = node.querySelector( '.header__media > img, .header__media > video' );
		const resize = () => ( media.style.height = `${ media.parentNode.getBoundingClientRect().height }px` );

		resize();
		window.addEventListener( 'resize', resize );
	}

	new SwapNavColors(node);
});




// 	} else {

// 	}
